module.exports = __webpack_public_path__ + "img/dog-grey.77d6382d.png";